export const updateMetadata = (title: string, description: string): void => {
  // Actualizar el título de manera forzada
  // Usar múltiples métodos para asegurar que se actualice
  document.title = title;
  
  // Forzar actualización también en el elemento <title> si existe
  const titleElement = document.querySelector('title');
  if (titleElement) {
    titleElement.textContent = title;
  }
  
  // Actualizar la descripción
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  }
};

export const updateFavicon = (country: string): void => {
  // Determinar qué favicon usar según el país
  let faviconPath = '/favicon.ico'; // Por defecto
  
  if (country === 'BR') {
    faviconPath = '/favicon-BR.ico';
  } else if (country === 'MX') {
    faviconPath = '/favicon-MX.ico';
  }
  
  // Buscar el link del favicon existente o crear uno nuevo
  let faviconLink = document.querySelector("link[rel='icon']") as HTMLLinkElement;
  
  if (!faviconLink) {
    faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    document.head.appendChild(faviconLink);
  }
  
  // Actualizar el href del favicon
  // Los archivos en la carpeta public se sirven desde la raíz
  faviconLink.href = faviconPath;
};

export const getMetadata = (): { title: string; description: string } => {
  return {
    title: document.title,
    description: document.querySelector('meta[name="description"]')?.getAttribute('content') || ''
  };
}; 